import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import { t } from "@/lib/i18n";
import { Button } from "@/components/ui/button";
import { Globe, LogIn, LogOut, ShieldCheck, FileText } from "lucide-react";

const Header = () => {
  const { language, setLanguage, user, logout, resetWizard } = useApp();
  const navigate = useNavigate();
  if (!language) return null;

  return (
    <header className="w-full border-b border-slate-200 bg-white/95 backdrop-blur sticky top-0 z-40">
      <div className="max-w-5xl mx-auto px-6 py-4 flex items-center justify-between gap-4">
        <button
          data-testid="header-home-btn"
          onClick={() => { resetWizard(); navigate("/"); }}
          className="flex items-center gap-3 group"
        >
          <div className="h-9 w-9 rounded-md bg-[#006C35] flex items-center justify-center text-white shadow-sm">
            <ShieldCheck className="h-5 w-5" />
          </div>
          <div className="text-start leading-tight">
            <div className="font-semibold text-slate-900 text-sm sm:text-base">{t(language, "appName")}</div>
            <div className="text-[11px] text-slate-500 hidden sm:block">GACA · CST · TGA</div>
          </div>
        </button>

        <div className="flex items-center gap-2">
          <Button
            data-testid="header-lang-toggle"
            variant="ghost"
            size="sm"
            onClick={() => setLanguage(language === "en" ? "ar" : "en")}
            className="text-slate-600 hover:text-[#006C35]"
          >
            <Globe className="h-4 w-4 me-2" />
            {language === "en" ? "العربية" : "English"}
          </Button>

          {user ? (
            <>
              <Button
                data-testid="header-history-btn"
                variant="ghost"
                size="sm"
                onClick={() => navigate("/history")}
                className="text-slate-600 hover:text-[#006C35] hidden sm:inline-flex"
              >
                <FileText className="h-4 w-4 me-2" />
                {t(language, "myComplaints")}
              </Button>
              <Button
                data-testid="header-logout-btn"
                variant="outline"
                size="sm"
                onClick={() => { logout(); navigate("/"); }}
              >
                <LogOut className="h-4 w-4 me-2" />
                {t(language, "logout")}
              </Button>
            </>
          ) : (
            <Button
              data-testid="header-login-btn"
              variant="outline"
              size="sm"
              onClick={() => navigate("/login")}
              className="border-[#006C35]/30 text-[#006C35] hover:bg-[#006C35] hover:text-white"
            >
              <LogIn className="h-4 w-4 me-2" />
              {t(language, "login")}
            </Button>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
